export default () => ({
    showEditForm: false,
    showAddNewAddressForm: false,
    showAddressesListModal: false,
    showOverlay: false,
    currentPage: null,
    activeTab: 'account',
    isOpen: false,
    selectedOption: '',
    init() {
        this.currentPage = window.location.pathname
        if (document.querySelector(`[data-value="${this.currentPage}"]`)){
            this.selectedOption = document.querySelector(`[data-value="${this.currentPage}"]`).innerText
        }
    },
    toggleAddNewAddressForm() {
        this.showAddNewAddressForm = !this.showAddNewAddressForm
        this.toggleOverlay(this.showAddNewAddressForm)
    },
    toggleEditAddressForm(index){
        this.showOverlay = !this.showOverlay
        this.showEditForm !== index ? this.showEditForm = index : this.showEditForm = null
        this.toggleOverlay(this.showEditForm !== null)
    },
    closeAllForms(){
        this.showOverlay = false
        this.showEditForm = false
        this.showAddNewAddressForm = false
        this.toggleOverlay(false)
    },
    toggleOverlay(flag){
        const body = document.querySelector('body')
        this.showOverlay = flag

        if(this.showOverlay){
            body.classList.add('overflow-hidden')
        }else{
            body.classList.remove('overflow-hidden')
        }
    },
    switchAccountView(tabName){
        this.activeTab = tabName
        window.location.hash = tabName
    },
    toggleDropDown(){
        const body = document.querySelector('body')
        this.isOpen = !this.isOpen
        if (this.isOpen){
            body.classList.add('overflow-hidden')
        }else {
            body.classList.remove('overflow-hidden')
        }
    },
    navigateToSelectedURL(event){
        this.isOpen = false
        this.selectedOption = event.target.innerText
        window.location.href = event.target.getAttribute("data-value")
    }
})
